<template>
  <div class="dbc-gl-page" :class="useRuntimeConfig().public.client">
    <div class="dbc-gl-content">
      <div class="dbc-gl-section">
        <UtilityText
          v-if="data?.content"
          class="dbc-text-color-black"
          :text="data.content"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()

const { setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale)

const { data } = await useFetch<AppsA11yInfo>('/api/app-iz-b', {
  baseURL: useRuntimeConfig().public.cms,
  query: {
    populate: 'deep',
    locale: locale,
  },
  deep: false,
  transform: (response: any) => {
    return response.data
  },
})

useHead({
  htmlAttrs: {
    class: 'webview',
  },
})
</script>
